import React, { PropTypes } from 'react'

import PaintSwatch from 'components/PaintSwatch'
import Price from 'components/Price'
import classNames from 'classnames'

const InitialsSummary = ({ initials }) => (
  <div className="customize-form-section">
    <div className="customize-form-section-header">
      Initials
      <Price value={initials.reduce((t, i) => (t + 
        ((i.selected && i.selected.characters && i.loc.price) || 0)
        ), 0)} />
    </div>
    <div className="customize-form-section-content">
      {
        initials.map(i => (
          <div className="initials-chooser" key={i.loc.id}>
            <div className="initials-chars">Initials: {i.selected.characters}</div>
            {i.selected.personalizationStyle &&
              <div>{i.selected.personalizationStyle.label}
                {i.selected.separateWithPeriods &&
                  <span>
                    , Separate with periods
                  </span>
                }
              </div>
            }
            <div key={i.paint.loc.id} className={classNames("paintfill-chooser", { "error" : i.selected != undefined && i.selected.enabled && !i.paint.valid })}>
              <div className="paintfill-selection">
                {i.paint.loc.label}
                <PaintSwatch paint={i.paint.selected} />
              </div>
            </div>
          </div>
        ))
      }
    </div>
  </div>
)

InitialsSummary.propTypes = {
  initials: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default InitialsSummary